"use client";

import { useEffect, useState } from "react";
import type { CarouselApi } from "../../carousel";

const initiallyRevealed = [0, 1, 2];

const useRevealedSlides = (api: CarouselApi) => {
  const [revealed, setRevealed] = useState<ReadonlySet<number>>(
    () => new Set(initiallyRevealed),
  );

  useEffect(() => {
    if (!api) {
      return;
    }
    const handleSlidesInView = () => {
      setRevealed((current) => {
        const inView = api.slidesInView();
        if (inView.every((index) => current.has(index))) {
          return current;
        }
        return new Set([...current, ...inView]);
      });
    };
    handleSlidesInView();
    api.on("slidesInView", handleSlidesInView);
    return () => {
      api.off("slidesInView", handleSlidesInView);
    };
  }, [api]);

  return revealed;
};

export default useRevealedSlides;
